import './styles/Button.scss';

export const BUTTON_TYPE_PRIMARY = 'Primary';
export const BUTTON_TYPE_SECONDARY = 'Secondary';

function Button(props) {
    const {
        buttonType = BUTTON_TYPE_PRIMARY,
        children,
        onClick,
        type = "",
    } = props;

    const _onClick = () => {
        if (onClick) {
            onClick();
        }
    }

    
    return (
        <button className={`button${buttonType}`} type={type} onClick={_onClick}>
           <a>{children}</a>
        </button>
    )
}

export default Button;
